<template>
  <IQOSModal @backdropClick="$emit('close')">
    <template #title>
      {{ $t("add_campaign.title") }}
    </template>

    <div>
      <BaseInput
        fullWidth
        class="mt-16"
        :readonly="false"
        v-model="form.title"
        :placeholder="$t('add_campaign.name_ph')"
      />
      <div class="gap-column-1xs mt-8 period-block">
        <v-date-picker v-model="form.period_start" :locale="calendarLocale" />
        <!-- <BaseInput :readonly="false" placeholder="Дата початку" /> -->
        <!-- <BaseInput :readonly="false" placeholder="Дата кінця" /> -->
        <span class="add-divider">-</span>
        <v-date-picker v-model="form.period_end" :locale="calendarLocale" />
      </div>
    </div>

    <template #actions>
      <BaseButton size="md" class="w-100" variant="secondary" color="red-4" @click="$emit('close')">
        {{ $t("add_campaign.cancel") }}</BaseButton
      ><BaseButton
        variant="secondary"
        size="md"
        color="green-5"
        class="w-100"
        :disabled="!form.title || !form.period_start || !form.period_end"
        @click="createCampaign"
        >{{ $t("add_campaign.confirm") }}</BaseButton
      >
    </template>
  </IQOSModal>
</template>
<script>
import moment from "moment";

import ReferralsAPI from "@/api/referrals";

export default {
  data() {
    return {
      form: {
        title: null,
        period_start: null,
        period_end: null,
      },
    };
  },
  methods: {
    createCampaign() {
      ReferralsAPI.createCampaign(
        this.form.title,
        this.form.period_start,
        this.form.period_end
      )
        .then((data) => {
          this.$store.dispatch("auditlog/write", {
            type: "marketing_new_campaign",
            payload: {
              title: this.form.title,
            },
          });

          this.$emit("created");
        })
        .catch((error) => {
          this.$store.dispatch("showError", "referrals_error");
        });
    },
  },
  computed: {
    calendarLocale() {
      return this.$i18n.locale == "ua" ? "uk" : this.$i18n.locale;
    },
  }
};
</script>
<style scoped>
.compagin-pop-up-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.line-split {
  font-size: 4vh;
  color: #ededed;
  margin: 0 16px;
}

.add-divider {
  color: #ededed;
  margin: 0 1vh;
  font-size: 26px;
}

.period-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

<style>
.vc-text-base {
  padding: 0.5vh 1vh;
  width: 100%;
  margin-right: 0 !important;
  text-align: center;
}
</style>